import { Component, EventEmitter, Inject, OnInit, Output, ViewChild } from '@angular/core';
import { User, UserCreate } from 'src/models/User.interface';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UserFormModalComponent } from '../user-add-form-modal/user-form-modal.component';
import { FormGroup } from '@angular/forms';
import Swal from 'sweetalert2';
import { UserChangeRoleModalComponent } from '../user-change-role-modal/user-change-role-modal.component';
import { MatPaginatorIntl, PageEvent } from '@angular/material/paginator';
import { PaginatorService } from 'src/home/paginator.service';
import { AuthService } from 'src/auth/auth.service';
import { ChangePasswordModalComponent } from '../user-change-password-modal/change-password-modal.component';
import { NewPasswordUser } from 'src/models/newPasswordUser.interface';
import { UsersService } from '../services/users.service';


@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css'],
  providers: [{ provide: MatPaginatorIntl, useClass: PaginatorService }]

})
export class UsersComponent implements OnInit {
  @Output() passwordChanged = new EventEmitter<void>();

  users: User[] = [];
  userForm!: FormGroup;
  totalUsers: number = 0;
  public noUsers: boolean = false
  public isLoading: boolean = false;
  public successMessage: string = '';
  public userRole: string = '';

  newPasswordUser: NewPasswordUser = {
    password: '',
    email_user_to_change: ''
  };

  constructor(
    private dialog: MatDialog,
    private authService: AuthService,
    private usersService: UsersService

  ) { }

  ngOnInit(): void {
    this.handleLoadUsers(1);
    this.userRole = this.authService.getCurrentUserRole();

    this.usersService.rolEmitter.subscribe((action) => {
      if (action === 'refresh') {
        this.handleLoadUsers(1);
      }
    });
  }


  openUserAddFormModal(): void {
    const dialogRef = this.dialog.open(UserFormModalComponent, {
      width: '70%',
      maxWidth: '600px',
      data: { title: 'Agregar Usuario' },
    });

    dialogRef.afterClosed().subscribe((newUser) => {
      if (newUser) {
        this.handleCreateUser(newUser);
      }
    });
  }

  handleLoadUsers(page: number): void {
    this.isLoading = true;
    this.usersService.getListUsers(page).subscribe(
      (data) => {
        this.isLoading = false;
        this.users = data.results;
        this.totalUsers = data.totalElements !== undefined ? data.totalElements : 0;
        if (data.results.length === 0) {
          this.noUsers = true;
        }
      },
      (error) => {
        this.isLoading = false;
      }
    );
  }

  openUserPasswordFormModal(user: User): void {
    const dialogRef = this.dialog.open(ChangePasswordModalComponent, {
      width: '70%',
      maxWidth: '600px',
      data: {
        title: 'Usuario',
        email: user.email
      },
    });

    dialogRef.afterClosed().subscribe((result: NewPasswordUser) => {
      if (result) {
        console.log(result);
      }
    });
  }

  handlePageEvent($event: PageEvent): void {
    this.handleLoadUsers($event.pageIndex + 1);
  }

  handleChangeRole(userRole: User): void {
    this.isLoading = true;
    if (typeof userRole.id === 'number' && !isNaN(userRole.id)) {
      const userId: number = parseInt(userRole.id.toString());
      const userWithIntegerId: User = { ...userRole, id: userId };
      this.usersService.changeUserRole(userWithIntegerId).subscribe(
        (response) => {
          this.isLoading = false;
          Swal.fire({
            text: 'Cambio de rol realizado exitosamente',
            icon: 'success',
            confirmButtonText: 'OK',
            confirmButtonColor: '#4caf50',
          });
        },
        (error) => {
          this.isLoading = false;
          Swal.fire({
            text: 'Error al cambiar el rol',
            icon: 'error',
            confirmButtonText: 'OK',
            confirmButtonColor: '#d33',
          });
        }
      );
    } else {
      console.error('El valor del ID no es un número válido.');
    }
  }

  handleCreateUser(newUser: UserCreate): void {
    this.isLoading = true;
    this.usersService.createUser(newUser).subscribe(
      () => {
        this.isLoading = false;
        Swal.fire({
          text: 'Usuario creado exitosamente',
          icon: 'success',
          confirmButtonText: 'OK',
          confirmButtonColor: '#4caf50',
        });
        this.handleLoadUsers(1);
      },
      (error) => {
        this.isLoading = false;
        Swal.fire({
          text: 'Error al crear usuario. Por favor, inténtalo de nuevo más tarde.',
          icon: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: '#d33',
        });
      }
    );
  }

  openRoleModal(user: User): void {
    const dialogRef = this.dialog.open(UserChangeRoleModalComponent, {
      width: '70%',
      maxWidth: '400px',
      data: {
        user: user,
        currentRole: user.role
      },
    });

    dialogRef.afterClosed().subscribe((selectedRole) => {
      if (selectedRole) {
        this.handleChangeRole(selectedRole);
      }
    });
  }


  openDeleteModal(user: User): void {
    Swal.fire({
      title: '¿Está seguro?',
      text: 'Esta acción no se puede deshacer',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#fb923c',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, eliminar usuario',
    }).then((result) => {
      if (result.isConfirmed) {
        this.handleDeleteUser(user);
      }
    });
  }

  handleDeleteUser(user: User): void {
    this.isLoading = true;
    this.usersService.deleteUser(user).subscribe(
      () => {
        this.isLoading = false;
        this.handleLoadUsers(1);
        Swal.fire({
          title: 'Usuario eliminado',
          text: 'El usuario ha sido eliminado correctamente',
          icon: 'success',
          confirmButtonColor: '#fb923c',
          confirmButtonText: 'Aceptar',
        });
      },
      (error) => {
        this.isLoading = false;
        Swal.fire({
          title: 'Error',
          text: 'Se produjo un error al intentar eliminar el usuario. Por favor, inténtelo de nuevo más tarde.',
          icon: 'error',
          confirmButtonText: 'Aceptar',
        });
      }
    );
  }

}
